// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"35f6fc69","453":"6a66188f","667":"41996464"}[chunkId] + ".chunk.js";
};